import { ApiError, NO_API_RETRY_CASES, NO_TRPC_RETRY_CASES } from "@platform/shared/errors";
import { QueryClient } from "@tanstack/react-query";
import { isTRPCClientError } from "~/shared/api/core/trpc.utils";

// Initialize the query client once, and pass it to the router for use in actions and loaders.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => {
        if (error instanceof ApiError && (NO_API_RETRY_CASES as Array<string>).includes(error.details.code)) {
          return false;
        }

        if (
          isTRPCClientError(error) &&
          error.data?.code &&
          (NO_TRPC_RETRY_CASES as Array<string>).includes(error.data.code)
        ) {
          return false;
        }

        // Gracefully retry if recoverable error
        return count < 3;
      },
      staleTime: 1000 * 60 * 3, // 3 minutes
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});
